import styled from "styled-components"

import { ClaimCard } from "./ClaimCard"
import { mobileBreakpoint, textDark, textGrey, useReferralAgent } from "./shared"

// Success state per Figma (node 64196-40142): centered column, 30px gaps, matches the form card height
const SuccessCard = styled(ClaimCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  min-height: 568px;
  padding: 28px 28px 24px;
  text-align: center;

  @media only screen and (width <= ${mobileBreakpoint}) {
    min-height: 0;
    padding: 40px 20px 32px;
  }
`

const SuccessCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border: 1.5px solid #7ee0f3;
  border-radius: 50%;
  background: #e6f6f9;
  color: #1e3a4c;

  svg {
    width: 22px;
    height: 22px;
  }
`

const SuccessHeading = styled.div`
  h2 {
    margin: 0;
    font-size: 1.375rem;
    font-weight: 600;
    color: ${textDark};
  }

  p {
    margin: 6px 0 0;
    color: ${textGrey};
    font-size: 0.9375rem;
  }
`

const SuccessText = styled.p`
  && {
    margin: 0;
    max-width: 360px;
    color: #334155;
    font-size: 1rem;
    line-height: 1.55;
  }
`

const SuccessNote = styled.p`
  && {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    color: ${textGrey};
    font-size: 0.8125rem;
  }

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
  }
`

export const ClaimSuccess = () => {
  const agent = useReferralAgent()
  const firstName = agent?.name.split(" ")[0] ?? "your agent"

  return (
    <SuccessCard as="div" role="status">
      <SuccessCheck aria-hidden>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12.5l4.5 4.5L19 7.5" />
        </svg>
      </SuccessCheck>
      <SuccessHeading>
        <h2>Claim submitted!</h2>
        <p>We&apos;ve processed your referral gift request.</p>
      </SuccessHeading>
      <SuccessText>
        We&apos;ve received your claim. A certified installer will reach out to you shortly to schedule your smart
        thermostat installation.
      </SuccessText>
      <SuccessNote>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
        {`Only ${firstName} sees you claimed. Nothing shared publicly.`}
      </SuccessNote>
    </SuccessCard>
  )
}
